import React from "react";
import {Section} from './Section'
import {resolve} from '@q4us-sw/q4us-ui/lib/Cell'
import {Button, Tag, Select, notification} from 'antd'
import moment from "moment";
import {submitDataWithConditions} from '../../api/api'
import {validSchemas,schemeTypes, schemeTypeIndexSubString, isEmpty} from "../util";

export const MOSS = ({data:values,fetchConfig,isEu=false,
                         onOSSRegistration,
    onOSSRegComplete, setValues
})=>{

    return <Section
        title={"OSS Information"}
        data={values}
        schema={"reg_approval__moss"}
        onChange={(val)=>{
            setValues(val)
        }}
        isEditable={(cfg, v)=>{
            if(v.status === 'REQUESTED_OSS_REG' && values.oss_special_schema_registered !== true){
                const schemes = validSchemas(values,isEu)
                if(cfg.name.startsWith('ss_reg_ioss_import') && schemes.includes(schemeTypes.Import))
                    return true;
                if(cfg.name.startsWith('ss_reg_ioss_non_union') && schemes.includes(schemeTypes.NonUnion))
                    return true;
                if(cfg.name.startsWith("nominated_rep_") && values.ss_reg_ioss_import_scheme_id != null)
                    return true;
                return cfg.name.startsWith('ss_reg_ioss_union') && schemes.includes(schemeTypes.Union);

            }
            return false;

        }}
        fetchConfig={async ()=>{
            return await fetchConfig({schema: "reg_approval__moss"})
        }}
        resolve={(props)=>{
            const fc_rep_only = (!values.voss_special_schema_registered) && (!values.vss_nr_want_to_register) && values.vss_nr_continue_without_oss;

            switch (props.name){
                case "oss_special_schema_registered":{
                    if(values.oss_special_schema_registered === true){
                        return <Tag className={'section-value'}>Yes</Tag>
                    }else if(fc_rep_only) {
                        return <Tag className={'section-value'}>FC Representation Only</Tag>
                    }else if(values.ss_nr_continue_without_oss === 'true'){
                        return <Tag className={'section-value'}>Continue Without MOSS</Tag>
                    }else{
                        if(values.status === 'REQUESTED_OSS_REG')
                            return <Button type={"primary"} className={"ant-danger"} onClick={async ()=>{
                                const {self_reg_establishment,self_reg_document,self_reg_site,self_reg_warehouse_vat, id, ...args} = values;
                                let oss_scheme_count = 0;
                                for (let val of Object.values(schemeTypeIndexSubString)) {
                                    if(isEmpty(args[`ss_reg_ioss_${val}_scheme_id`])){
                                        oss_scheme_count += 1;
                                        args[`ss_reg_ioss_${val}_scheme_id`] = null
                                        args[`ss_reg_ioss_${val}_scheme_country`] = null
                                        args[`ss_reg_ioss_${val}_scheme_requested`] = null
                                        args[`ss_reg_ioss_${val}_scheme_commenced`] = null
                                    }
                                    else {
                                        if(!(args[`ss_reg_ioss_${val}_scheme_country`] && args[`ss_reg_ioss_${val}_scheme_requested`] && args[`ss_reg_ioss_${val}_scheme_commenced`])){
                                            notification.warn({message:"One or many OSS fields are incomplete. Check again"})
                                            return
                                        }
                                    }
                                }
                                if(oss_scheme_count===3){
                                    notification.warn({message:"No OSS fields are filled. Check again"})
                                    return
                                }
                                const res = await submitDataWithConditions('self_registration', {...args,status: 'REQUEST_APPROVAL',oss_special_schema_registered: true}, [{ key: 'id', value: id }, { key: 'status', value: 'REQUESTED_OSS_REG' }])
                                if(res.status === 200 && (res.data || {}).rowCount === 1){
                                    notification.success({message:"Application Moved to Request Approval Stage"})
                                }
                                else{
                                    notification.error({message:"Moving to Request Approval Stage failed"})
                                }
                                if(res.status === 200 && (res.data || {}).rowCount === 1 && onOSSRegComplete) {
                                    await onOSSRegComplete()
                                }
                            }}>Complete OSS Registration</Button>
                        else
                            return <Tag>Pending</Tag>
                    }
                }
                case "ss_nr_oss_preferred_country":{

                    if(values.vss_nr_oss_preferred_country != null || values.status !== 'SUBMITTED' || values.oss_special_schema_registered === true || fc_rep_only){
                        return <Tag className={'section-value'}>{resolve(props)}</Tag>
                    }else{
                        return <Select showSearch optionFilterProp={'children'} style={{minWidth: 180}} value={values.ss_nr_oss_preferred_country} onChange={(e)=>{
                            const schemes = validSchemas(values,isEu)
                            const delta = {
                                ss_nr_oss_preferred_country: e,
                                ss_reg_ioss_import_scheme_country: schemes.includes(schemeTypes.Import) ? e: undefined,
                                ss_reg_ioss_non_union_scheme_country:schemes.includes(schemeTypes.NonUnion) ? e: undefined,
                                ss_reg_ioss_union_scheme_country:schemes.includes(schemeTypes.Union) ? e: undefined

                            }
                            setValues({...values, ...delta})
                        }}>
                            {props.enums.map(([k,v])=><Select.Option key={k} value={k}>{v}</Select.Option>)}
                        </Select>
                    }
                }
                default:
                    return <Tag className={'section-value'}>{resolve(props)}</Tag>
            }
        }}
    />
}
